/* BORSTA by LINTEL PDP: gallery (dots/thumbs, colour filter), colour swatches -> variant id, open brand cart drawer after any add */
(function () {
  var tr = document.querySelector('[data-bt-track]'), dots = document.querySelector('[data-bt-dots]'), thumbs = document.querySelector('[data-bt-thumbs]');
  function vis() { return tr ? Array.prototype.filter.call(tr.children, function (e) { return !e.hidden; }) : []; }
  function drawDots() {
    if (!tr || !dots) return;
    var n = vis().length; dots.innerHTML = Array(n + 1).join('<span></span>');
    dots.querySelectorAll('span').forEach(function (d, k) { d.addEventListener('click', function () { tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }); });
    upd();
  }
  function upd() {
    if (!tr || !dots) return;
    var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
    dots.querySelectorAll('span').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    if (thumbs) { var v = vis(); thumbs.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-on', v[i] && b.dataset.i === v[i].dataset.i); }); }
  }
  if (tr) {
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { var v = vis(); for (var k = 0; k < v.length; k++) if (v[k].dataset.i === b.dataset.i) tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); });
    });
    drawDots();
  }
  /* colour swatches: set the variant id, show that colour's photos first (alt prefix "Black — " / "Grey — ") */
  var sw = document.querySelectorAll('[data-bt-sw] input');
  function pick(inp) {
    var id = document.querySelector('form[data-bt-add] input[name=id]'); if (id) id.value = inp.value;
    var lab = document.querySelector('[data-bt-colour]'); if (lab) lab.textContent = inp.dataset.name;
    if (tr) {
      var col = inp.dataset.name.toLowerCase(), imgs = tr.querySelectorAll('img');
      for (var k = 0; k < imgs.length; k++) if ((imgs[k].alt || '').toLowerCase().indexOf(col + ' ') === 0) { tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); break; }
    }
    try { var u = new URL(location.href); u.searchParams.set('variant', inp.value); history.replaceState(null, '', u); } catch (e) {}
  }
  sw.forEach(function (inp) { inp.addEventListener('change', function () { pick(inp); }); if (inp.checked) pick(inp); });
  /* before / after */
  document.querySelectorAll('[data-bt-ba]').forEach(function (ba) {
    var r = ba.querySelector('input'), a = ba.querySelector('.bt-ba__after'), h = ba.querySelector('.bt-ba__h');
    r.addEventListener('input', function () { a.style.clipPath = 'inset(0 0 0 ' + r.value + '%)'; h.style.left = r.value + '%'; });
  });
  /* brand cart drawer after any add (Kaching or native) */
  var pending = false;
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) { if (r && r.ok && !pending) { pending = true; setTimeout(function () { pending = false; if (window.BT) window.BT.openCart(); }, 250); } }).catch(function () {});
      }
      return p;
    };
  }
})();
/* BORSTA: review carousel */
(function () {
  document.querySelectorAll('[data-bt-cq]').forEach(function (c) {
    var tr = c.querySelector('.bt-cq__track');
    c.querySelectorAll('.bt-cq__nav button').forEach(function (b) {
      b.addEventListener('click', function () { tr.scrollBy({ left: +b.dataset.d * tr.clientWidth, behavior: 'smooth' }); });
    });
  });
  var s = document.querySelector('[data-bt-shades]');
  if (s) s.addEventListener('click', function () { var d = document.getElementById('bt-shades'); if (d) d.open = true; });
})();


/* BORSTA: every BUY NOW button scrolls to the offer (Kaching bar or the native box) */
(function () {
  document.querySelectorAll('[data-bt-gopack]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); var p = document.querySelector('kaching-bundle') || document.querySelector('[data-bt-pack]') || document.querySelector('.bt-form'); if (p) p.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  });
})();

/* ===== 10-02 (Edvin): Add to cart NEVER goes to /cart - every add (theme ATC, Kaching ATC, any /cart/add form) opens the BT brand cart drawer ===== */
(function () {
  if (window.__bt_atc) return; window.__bt_atc = 1;
  function open() { if (window.BT && window.BT.openCart) return window.BT.openCart(); if (window.__lntOpen) return window.__lntOpen(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (!ok && window.__lntOpen) { window.__lntOpen(); ok = true; } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
